import { get } from 'svelte/store';
import { api } from '../../../../../../helpers';
import { list, pagination, tab, currentPage, searchValue, selectedFilterTitle, filtersData, selectedFilters, isShowFilters, isShowClearAction, selectedFiltersCount, isShowDeleteModal, deletePublicationId } from '../store';
import { addToast } from '../../../../../custom/Toasts/store';
export const openDeleteModal = (id) => {
    isShowDeleteModal.set(true);
    deletePublicationId.set(id);
};
export const closeDeleteModal = async ({ detail: { report } }) => {
    if (report) {
        await deletePublication();
    }
    isShowDeleteModal.set(false);
    deletePublicationId.set(0);
};
const setListAndPagination = async (page = 1) => {
    const data = await getList(page);
    list.set(data.results);
    pagination.set(data.pagination);
};
export const copyPublication = async (id) => {
    const { ok } = await api(`/api/v1/publication-editor/publication/copy/${id}/`, 'POST');
    if (!ok) {
        addToast('Произошла ошибка при копировании');
        return;
    }
    await setListAndPagination();
    addToast('Публикация успешно скопирована', 'success');
};
export const getFiltersData = async () => {
    const response = await api('/api/v1/publication-editor/params/');
    const data = await response.json();
    return data;
};
export const resetFilters = () => {
    const title = get(selectedFilterTitle);
    const filters = get(selectedFilters);
    if (title === 'Фильтры') {
        filters.date.beforeApplyValue = [];
        filters.flows.beforeApplyValue = [];
        filters.group.beforeApplyValue = [];
        filters.sections.beforeApplyValue = [];
        filters.tags.beforeApplyValue = [];
    }
    if (title === 'По дате') {
        selectedFilters.update((n) => (Object.assign(Object.assign({}, n), { date: Object.assign(Object.assign({}, n.date), { beforeApplyValue: [] }) })));
        return;
    }
    if (title === 'По группе') {
        selectedFilters.update((n) => (Object.assign(Object.assign({}, n), { group: Object.assign(Object.assign({}, n.group), { beforeApplyValue: [] }) })));
        return;
    }
    if (title === 'По потоку') {
        selectedFilters.update((n) => (Object.assign(Object.assign({}, n), { flows: Object.assign(Object.assign({}, n.flows), { beforeApplyValue: [] }) })));
        return;
    }
    if (title === 'По разделу') {
        selectedFilters.update((n) => (Object.assign(Object.assign({}, n), { sections: Object.assign(Object.assign({}, n.sections), { beforeApplyValue: [] }) })));
        return;
    }
    if (title === 'По тегу') {
        selectedFilters.update((n) => (Object.assign(Object.assign({}, n), { tags: Object.assign(Object.assign({}, n.tags), { beforeApplyValue: [] }) })));
        return;
    }
    selectedFilters.set(filters);
};
export const openFiltersModal = () => {
    const filters = get(selectedFilters);
    selectedFilterTitle.set('Фильтры');
    isShowFilters.set(!get(isShowFilters));
    filters.date.beforeApplyValue = filters.date.value;
    filters.flows.beforeApplyValue = filters.flows.value;
    filters.group.beforeApplyValue = filters.group.value;
    filters.sections.beforeApplyValue = filters.sections.value;
    filters.tags.beforeApplyValue = filters.tags.value;
    selectedFilters.set(filters);
};
export const applyFilters = async () => {
    const filters = get(selectedFilters);
    const title = get(selectedFilterTitle);
    if (title === 'Фильтры') {
        isShowFilters.set(false);
        filters.date.value = filters.date.beforeApplyValue;
        filters.flows.value = filters.flows.beforeApplyValue;
        filters.group.value = filters.group.beforeApplyValue;
        filters.sections.value = filters.sections.beforeApplyValue;
        filters.tags.value = filters.tags.beforeApplyValue;
        selectedFilters.set(filters);
        currentPage.set(1);
        selectedFiltersCount.set(Object
            .values(get(selectedFilters))
            .map(({ value }) => value)
            .flat()
            .filter(Boolean)
            .length);
        await setListAndPagination();
    }
    const isFillFields = !!Object
        .values(filters)
        .filter(el => el.beforeApplyValue.length)
        .length;
    isShowClearAction.set(isFillFields);
    selectedFilterTitle.set('Фильтры');
};
export const selectFilter = ({ title, value }) => {
    selectedFilterTitle.set(title);
};
export const sliceItems = (items) => {
    const copyItems = [...items];
    return [copyItems.slice(0, 2), copyItems.slice(2)];
};
export const deletePublication = async () => {
    const response = await api(`/api/v1/publication-editor/publication/delete/${get(deletePublicationId)}/`, 'DELETE');
    if (!response.ok) {
        console.log('Delete is failed!');
        return;
    }
    addToast('Публикация успешно удалена', 'success');
    list.update((n) => n.filter(item => item.pk !== get(deletePublicationId)));
};
export const search = async () => {
    currentPage.set(1);
    await setListAndPagination();
};
const createQueryFromArray = (array, query) => {
    return array.map(({ pk }) => `&${query}=${pk}`).join('');
};
export const getList = async (page = 1) => {
    let path = `/api/v1/publication-editor/publication/list/?page=${page}&visible_page_count=7`;
    const tabValue = get(tab);
    const search = get(searchValue);
    const filters = get(selectedFilters);
    if (search.length) {
        path += `&full_text_search=${search}`;
    }
    if (tabValue === 'deactivated') {
        path += '&deactivated=true';
    }
    if (tabValue === 'all') {
        path += '&published=true';
    }
    if (tabValue === 'delayed') {
        path += '&delayed=true';
    }
    if (tabValue === 'drafts') {
        path += '&draft=true';
    }
    if (filters.date.value.length) {
        const [startDate, endDate] = filters.date.value;
        if (startDate === null || startDate === void 0 ? void 0 : startDate.length) {
            path += `&start_date=${startDate}`;
        }
        if (endDate === null || endDate === void 0 ? void 0 : endDate.length) {
            path += `&end_date=${endDate}`;
        }
    }
    if (filters.flows.value.length) {
        path += createQueryFromArray(filters.flows.value, 'flows');
    }
    if (filters.group.value.length) {
        path += createQueryFromArray(filters.group.value, 'feed_group');
    }
    if (filters.tags.value.length) {
        path += createQueryFromArray(filters.tags.value, 'feed_tags');
    }
    if (filters.sections.value.length) {
        path += createQueryFromArray(filters.sections.value, 'section');
    }
    const response = await api(path);
    const data = await response.json();
    return data;
};
export const changePagination = async ({ detail: { page } }) => {
    currentPage.set(page);
    await setListAndPagination(page);
    document.body.scrollTop = document.documentElement.scrollTop = 0;
};
export const init = async () => {
    await setListAndPagination(get(currentPage));
    filtersData.set(await getFiltersData());
    document.body.scrollTop = document.documentElement.scrollTop = 0;
};
export const destroy = () => {
    list.set([]);
};
